(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blends-test"]) return;
  try {
    

function squaressHeight() {
  var $squaresWidth = $('.preview[data-shape="squares"]').width();
  var $squaresCol = $('.preview[data-shape="squares"]').attr('data-col').split('-')[1]; 
  $('.preview[data-shape="squares"]').height($squaresWidth + ($squaresCol * 2)); // math accounts for borders 
  $('.preview[data-shape="squares"] .preview-overlay').height($squaresWidth + ( ($squaresCol * 2) - 1) ); 
} 
  
function diamondsHeight() {
  var $diamondsWidth = $('.preview[data-shape="diamonds"]').width();
  var $diamondsCol = $('.preview[data-shape="diamonds"]').attr('data-col').split('-')[1]; 
  var $cubeWidth = (($diamondsWidth / $diamondsCol));  
  var $tileWidth = ($cubeWidth / 1.75);

  
  console.log($diamondsWidth);
  console.log($diamondsCol);  
  console.log($cubeWidth);
  console.log($tileWidth)
  $('.preview[data-shape="diamonds"]').height($diamondsWidth);
  
  $('.preview .diamonds-row').css('margin-bottom', $cubeWidth * -.265);
  $('.preview .diamonds-row:first-child').css('margin-top', $cubeWidth * -.95);
  $('.preview .diamonds-row:nth-child(odd)').width($diamondsWidth + $cubeWidth).css('left', $cubeWidth / -2); 
  
  $('.preview .cube-wrap').width($cubeWidth);  
  $('.preview .cube-wrap').height($tileWidth * 2);
  $('.preview .cube .tile').width($tileWidth).height($tileWidth); 
  
} 

$( document ).ready(function() {

  squaressHeight();
  diamondsHeight(); 
  
  var $type = 'advanced';
  var $shape = 'squares'; 
  $('.blends-nav .btn-tag, .blends-type .switch-type').click(function() { 
    if( !$(this).hasClass('active') ) {

      $type = $(this).data('tag'); 
      console.log($type);
      $shape = $(this).data('shape');
      console.log($shape);

      // nav btns
      if ( !$(this).hasClass('switch-type') ) {
        $('.blends-nav .btn-tag').removeClass('active');
        $(this).addClass('active');

        // new form
        $('#shape li.selected').click();
        if ($shape == 'squares') { 
          $('#shape li[data-index="1"]').click();
        };
        if ($shape == 'diamonds') {
          $('#shape li[data-index="5"]').click();
        };
        if ($shape == 'mid-mod') {
          $('#shape li[data-index="6"]').click();
        };
        $('#shape:not(.open)').addClass('open'); 
 
      } 

      // type
      if( !$('.blends-panel .blends-type[data-tag="' + $type + '"]').hasClass('active') ) {
        $('.blends-panel .blends-type').removeClass('active');
        $('.blends-panel .blends-type[data-tag="' + $type + '"]').addClass('active');
      }
      
      // colors panel
      $('.blends-panel .switch-type').removeClass('current-shape');
      $('.blends-panel .switch-type[data-shape="' + $shape + '"]').addClass('current-shape');
      if ( $type == 'advanced') { 
        if( !$('.blends-advanced .preview[data-shape="' + $shape + '"]').hasClass('active') ) {
          $('.blends-advanced .preview').removeClass('active');
          $('.blends-advanced .preview[data-shape="' + $shape + '"]').addClass('active');
        }
      } else { // presets
        $('.blends-presets .blend').removeClass('current-shape'); 
        $('.blends-presets .blend[data-shape="' + $shape + '"]').addClass('current-shape');  
        $('.blends-presets .blend.current-shape')[0].click(); 
      }
       
     
      
      
      

      
    }
  }); 

  /*$('.blends-type .switch-type').click(function() {
    $type = $(this).data('tag');

    // panel
      if( !$('.blends-panel .blends-type[data-tag="' + $type + '"]').hasClass('active') ) {
        $('.blends-panel .blends-type').removeClass('active');
        $('.blends-panel .blends-type[data-tag="' + $type + '"]').addClass('active');
      }
    
  });*/
  

  var $first = 0;
  var $row = 6;
  var $grid = $row * $row;
  
  // Select Color
  $('.colors .swatch').click(function() {
    console.log($type);

    if (!$(this).parent().parent().hasClass('blend')) {
  
    	var $prevColor = $(this).parent().find('.active')
    	$prevColor.removeClass('active');
        $(this).addClass('active');
    
    	if ( !$(this).parent().hasClass('selected') ) {
    	  $(this).parent().addClass('selected');
    	}
    
    	var $prevAnim = 0;
        if( $('.preview-overlay').hasClass('anim-2') ) {                         
          $('.preview-overlay').removeClass('anim-2');
          var $prevAnim = 2;
        }
        $('.preview-overlay').addClass('anim-1');
    	updatePreview($prevAnim);
    
    	// update form 
    	var $codePrev = $prevColor.find('.code').text();
    	if ($codePrev == '') {
    	  $codePrev = 'n/a'; 
    	}
    	var $code = $(this).find('.code').text(); 
    	if ($(this).parent().parent('.set').hasClass('set-1')) { 
          
          /* old form
    	  $('.free-quote-body select[name="MultipleChoice2"] option').prop('selected', false);  
    	  var $list = $('select[name="MultipleChoice2"]');
    	  var $option = $('.free-quote-body select[name="MultipleChoice2"] option:contains("' + $code + '")');  
          $option.prop('selected', true); 
    	  $list.scrollTop($list.scrollTop() + $option.position().top);*/
    
          // new form
          $('#primary-color li.selected').click();
          $('#primary-color:not(.open)').addClass('open'); 
          $('#primary-color li').each(function() {
            if ( $(this).text().split(' ').pop() == $code ) {
              $(this).click();
            }
          }); 
          
    	} else {
    
          /* old form
    	  var $optionPrev = $('.free-quote-body select[name="MultipleChoice3"] option:contains("' + $codePrev + '")'); 
    	  $optionPrev.prop('selected', false);
    	  var $list = $('select[name="MultipleChoice3"]');
    	  var $option = $('.free-quote-body select[name="MultipleChoice3"] option:contains("' + $code + '")');
          $option.prop('selected', true); 
    	  $list.scrollTop($list.scrollTop() + $option.position().top);*/
    
          // new form
          $('#secondary-color li.selected').click(); 
          $('#secondary-color:not(.open)').addClass('open');
          $('#secondary-color li').each(function() {
            if ( $(this).text().split(' ').pop() == $code ) {
              $(this).click();
            }
          }); 
          
    	} 

      }
    
    });

    // Add Color
    $('.add-set').click(function() {
  	$('.colors').find('.set.active').last().next('.set').addClass('active');
  	activeCount = $('.colors .set.active').length;
  	if (activeCount > 3) {
  		$(this).addClass('disabled');
  	}
  	
  	// resets
  	if (activeCount == 3) {
  		$('.colors .set.active:nth-child(1) input').val(50)
  		$('.colors .set.active:nth-child(2) input, .colors .set.active:nth-child(3) input').val(25);
  	}
  	if (activeCount == 4) {
  		$('.colors .set.active:nth-child(1) input').val(50);
  		$('.colors .set.active:nth-child(2) input, .colors .set.active:nth-child(3) input').val(20);
  		$('.colors .set.active:nth-child(4) input').val(10);
  	}
  	
    });
    
    // Remove Color
    $('.remove-set').click(function() {
  	var $prevColor = $(this).parent('.set').find('.swatch.active')
  	$(this).parent('.set').find('.swatch.active').removeClass('active') 
  	
  	$(this).parent('.set').find('.swatches').removeClass('selected')
      $('.colors').find('.set.active').last().removeClass('active') 
  	activeCount = $('.colors .set.active').length; 
  	if (activeCount < 4) {
        if ($('.add-set').hasClass('disabled')) {                             
  		$('.add-set').removeClass('disabled');
        }
  	}
                                              
      // resets 
      if (activeCount == 2) {
  		$('.colors .set.active:nth-child(1) input').val(80); 
  		$('.colors .set.active:nth-child(2) input').val(20);
  	}
  	if (activeCount == 3) {
  		$('.colors .set.active:nth-child(1) input').val(50);
  		$('.colors .set.active:nth-child(2) input, .colors .set.active:nth-child(3) input').val(25);
  	}
      
      // update preview
      var $prevAnim = 0;
      if( $('.preview-overlay').hasClass('anim-2') ) {                         
        $('.preview-overlay').removeClass('anim-2');
        var $prevAnim = 2;
      }
      $('.preview-overlay').addClass('anim-1');
  	updatePreview($prevAnim);
                          
      // update form 
      var $codePrev = $prevColor.find('.code').text();
  	if ($codePrev == '') {
  	  $codePrev = 'n/a'; 
  	}
  
      /* old form
      var $optionPrev = $('.free-quote-body select[name="MultipleChoice3"] option:contains("' + $codePrev + '")');
  	$optionPrev.prop('selected', false);*/
  
      // new form
      $('#secondary-color li.selected').click(); 
      
    });
                       
                          
    // Change Percent                  
    $('.set input').on('change', function() {           
                          
  	var $val = $(this).val();
      var activeCount = $('.colors .set.active').length;
  
      // 5 min, 95 max 
      if ($val < 5) {
  		$val = 5;
  		$(this).val($val);
          $(this).attr('value', $val); 
  	}
  	if (activeCount == 2) {
        if ($val > 95) {
            $val = 95;
            $(this).val($val);
            $(this).attr('value', $val); 
        }
  	}
  	if (activeCount == 3) {
        if ($val > 90) {
            $val = 90;
            $(this).val($val);
            $(this).attr('value', $val); 
        }
  	}
  	if (activeCount == 4) { 
        if ($val > 85) {
            $val = 85;
            $(this).val($val);
            $(this).attr('value', $val); 
        }
  	}
                      
      // 2 active
  	if (activeCount == 2) {
          if ($(this).parent().parent('.set').hasClass('set-1')) {
          	$('.set-2 input').val(100 - $val);
              $('.set-2 input').attr('value', 100 - $val);
          }
  		if ($(this).parent().parent('.set').hasClass('set-2')) {
          	$('.set-1 input').val(100 - $val);
              $('.set-1 input').attr('value', 100 - $val);
          }
  	}
        
      // 3 active
      if (activeCount == 3) {  
          var $val1 = $('.set-1 input').val()
          var $val2 = $('.set-2 input').val()
          // 1
          if ($(this).parent().parent('.set').hasClass('set-1')) {
              $newVal3 = (100 - $val2) - $val;
              if ($newVal3 < 5) {
  				$newVal3 = 5;
  				var $newVal2 = (100 - $val1) - 5;
  				$('.set-2 input').val($newVal2);
  				$('.set-2 input').attr('value', $newVal2);
  			}
          	$('.set-3 input').val($newVal3);
          }
  		// 2
          if ($(this).parent().parent('.set').hasClass('set-2')) {
              $newVal3 = (100 - $val1) - $val;
              if ($newVal3 < 5) {
  				$newVal3 = 5;
  				var $newVal1 = (100 - $val) - 5;
  				$('.set-1 input').val($newVal1);
                  $('.set-1 input').attr('value', $newVal1);
  			}
          	$('.set-3 input').val($newVal3);
              $('.set-3 input').attr('value', $newVal3);
          }
          // 3
          if ($(this).parent().parent('.set').hasClass('set-3')) {
              $newVal2 = (100 - $val1) - $val;
              if ($newVal2 < 5) {
  				$newVal2 = 5;
  				var $newVal1 = (100 - $val) - 5;
  				$('.set-1 input').val($newVal1);
  			}
          	$('.set-2 input').val($newVal2);
  		    $('.set-2 input').attr('value', $newVal2); 
          }
  		
  	}
                          
      // 4 active 
      if (activeCount == 4) {    
          var $val1 = $('.set-1 input').val()
          var $val2 = $('.set-2 input').val()
  		var $val3 = $('.set-3 input').val()
  		var $val4 = $('.set-4 input').val()
          // 1
          if ($(this).parent().parent('.set').hasClass('set-1')) {
              $newVal4 = (100 - $val2 - $val3) - $val;
              if ($newVal4 < 5) {
  				$newVal4 = 5;
  				var $newVal3 = (100 - $val1 - $val2) - 5;
                  if ($newVal3 < 5) {
  					$newVal3 = 5;
                      var $newVal2 = (100 - $val1) - 5 - 5;
  					$('.set-2 input').val($newVal2);
  					$('.set-2 input').attr('value', $newVal2);
  					if ($newVal2 < 5) {
                          $newVal2 = 5;
                          var $newVal1 = 100 -5 - 5 - 5;
                          $('.set-1 input').val($newVal1);
                          $('.set-1 input').attr('value', $newVal1);
                      }
                      $('.set-2 input').val($newVal2);
                      $('.set-2 input').attr('value', $newVal2);
  				}
  				$('.set-3 input').val($newVal3);
                  $('.set-3 input').attr('value', $newVal3);
  			}
          	$('.set-4 input').val($newVal4);
              $('.set-4 input').attr('value', $newVal4);
          }
  		// 2   
          if ($(this).parent().parent('.set').hasClass('set-2')) {
              $newVal4 = (100 - $val1 - $val3) - $val;
              if ($newVal4 < 5) {
  				$newVal4 = 5;
  				var $newVal3 = (100 - $val1 - $val2) - 5;
                  if ($newVal3 < 5) {
  					$newVal3 = 5;
                      var $newVal1 = (100 - $val2) - 5 - 5;
  					$('.set-1 input').val($newVal1);
                      $('.set-1 input').attr('value', $newVal1);
  					if ($newVal1 < 5) {
                          $newVal1 = 5;
                          var $newVal2 = 100 -5 - 5 - 5;
                          $('.set-2 input').val($newVal2);
  						$('.set-2 input').attr('value', $newVal2);
                      }
                      $('.set-1 input').val($newVal1);
  					$('.set-1 input').attr('value', $newVal1);
  				}
  				$('.set-3 input').val($newVal3);
  				$('.set-3 input').attr('value', $newVal3);
  			}
          	$('.set-4 input').val($newVal4);
  			$('.set-4 input').attr('value', $newVal4);
          }
  		// 3      
          if ($(this).parent().parent('.set').hasClass('set-3')) {
              $newVal4 = (100 - $val1 - $val2) - $val;
              if ($newVal4 < 5) {
  				$newVal4 = 5;
  				var $newVal2 = (100 - $val1 - $val3) - 5;
                  if ($newVal2 < 5) {
  					$newVal2 = 5;
                      var $newVal1 = (100 - $val3) - 5 - 5;
  					$('.set-1 input').val($newVal1);
  					if ($newVal1 < 5) {
                          $newVal1 = 5;
                          var $newVal3 = 100 -5 - 5 - 5;
                          $('.set-3 input').val($newVal3);
                          $('.set-3 input').attr('value', $newVal3);
                      }
                      $('.set-1 input').val($newVal1);
                      $('.set-1 input').attr('value', $newVal1);
  				}
  				$('.set-2 input').val($newVal2);
                  $('.set-2 input').attr('value', $newVal2);
  			}
          	$('.set-4 input').val($newVal4);
              $('.set-4 input').attr('value', $newVal4);
          }
          // 4       
          if ($(this).parent().parent('.set').hasClass('set-4')) {
              $newVal3 = (100 - $val1 - $val2) - $val;
              if ($newVal3 < 5) {
  				$newVal3 = 5;
  				var $newVal2 = (100 - $val1 - $val4) - 5;
                  if ($newVal2 < 5) {
  					$newVal2 = 5;
                      var $newVal1 = (100 - $val4) - 5 - 5;
  					$('.set-1 input').val($newVal1);
                      $('.set-1 input').attr('value', $newVal1);
  					if ($newVal1 < 5) {
                          $newVal1 = 5;
                          var $newVal4 = 100 -5 - 5 - 5;
                          $('.set-4 input').val($newVal4);
  						$('.set-4 input').attr('value', $newVal4);
                      }
                      $('.set-1 input').val($newVal1);
  					$('.set-1 input').attr('value', $newVal1);
  				}
  				$('.set-2 input').val($newVal2);
  				$('.set-2 input').attr('value', $newVal2);
  			}
          	$('.set-3 input').val($newVal3);
  			$('.set-3 input').attr('value', $newVal3);
          }
  		
  	}  
   
  	var $prevAnim = 0;
      if( $('.preview-overlay').hasClass('anim-2') ) {                         
        $('.preview-overlay').removeClass('anim-2');
        var $prevAnim = 2;
      }
      $('.preview-overlay').addClass('anim-1');
  	updatePreview($prevAnim);
                          
    });                    
                    
    // Square Footage Update
    $('.blends-panel .quantity input').on('change', function() {
  
  	var $len = $(this).val().length;
  	/*if ($len > 1) {
  		$len = $len + 1;
  	}*/
  	$(this).attr('size', $len); 
  
  	  var $prevAnim = 0;
      if( $('.preview-overlay').hasClass('anim-2') ) {                         
        $('.preview-overlay').removeClass('anim-2');
        var $prevAnim = 2;
      }
      $('.preview-overlay').addClass('anim-1');

      var $this = $(this); 
      setTimeout(function( ){
        var $sqft = $this.val();
        const nearest_sq = n => Math.pow(Math.round(Math.sqrt(n)), 2); 
        var $grid = nearest_sq($sqft);
        if ( $grid < 49 ) {
          $grid = 49;
        }   
        if ( $grid > 100 ) {
          $grid = 100;
        }
        var $row = Math.sqrt($grid);

        $('.preview').each(function() {
          if ($(this).data('shape') == 'diamonds') {
            var $colCubes = Math.ceil($row / 1.5);  
            var $rowCubes = $colCubes * 1.3;
            console.log($colCubes);
            console.log($rowCubes);
            $(this).find('.cube-wrap.show').removeClass('show'); 
            $(this).find('.tile.show').removeClass('show');
            $(this).attr('data-col', 'col-' + $colCubes ); 
            for(var i = 0; i <= $rowCubes; i++) {
              if (i % 2 == 0) {
                console.log('even'); 
                $colCubesTemp = $colCubes + 1;
              } else { // odd row
                console.log('odd');
                $colCubesTemp = $colCubes;
              };
              var ii = 1; 
              
              $('.diamonds-row').eq(i).find('.cube-wrap').each(function() {
                if (ii <= $colCubesTemp) {
                  $(this).addClass('show');
                  $(this).find('.tile').addClass('show');
                }
                ii++;
              });
  
              diamondsHeight();
  
            }
            
          } else { // not diamonds
            
            $(this).find('.tile.show').removeClass('show'); 
            $(this).attr('data-col', 'col-' + $row ); 
            for(var i = 1; i <= $grid; i++) {  
              $('.preview .tile').eq(i).addClass('show'); 
            }
            
          }
          
        });

        updatePreview($prevAnim);  
      }.bind($this), 400); 
  
      /* old form
      $('.free-quote-body input[name="Number"]').val($sqft).change();*/
  
      // new form
      $('#square-footage li.selected').click();
      $('#square-footage:not(.open)').addClass('open');
      if ($sqft < 25) {
        $('#square-footage li[data-index="1"]').click();
      } else if ($sqft < 50) {
        $('#square-footage li[data-index="2"]').click();
      } else if ($sqft < 150) {
        $('#square-footage li[data-index="3"]').click();
      } else if ($sqft < 250) {
        $('#square-footage li[data-index="4"]').click();
      } else {
        $('#square-footage li[data-index="5"]').click(); 
      }
                       
    }); 
                               
    
    // Update Preview                                 
    function updatePreview($prevAnim) {  
  
  	$('.tile.show').addClass('primary');
  	$('.tile.show').removeClass('color-2');
  	$('.tile.show').removeClass('color-3');
  	$('.tile.show').removeClass('color-4');
  
      setTimeout(function(){
                               
        var $grid = $('.preview .tile.show').length;     	
  
  	  $('.tile').css('background-image', 'none'); 
  		
  	  // 1
        if( $('.set-1 .swatches').hasClass('selected') ) {
          var $img = $('.set-1 .swatch.active').css('background-image');
          $img = $img.replace('url(','').replace(')','').replace(/\"/gi, "");
  		$('.tile.show.primary').css('background-image', 'url(' + $img + ')');
        }
  	 
        for (let i = 2; i < 5; i++) {    
          if( $('.set-' + i + ' .swatches').hasClass('selected') ) {
            var $img2 = $('.set-' + i + ' .swatch.active').css('background-image');
            $img2 = $img2.replace('url(','').replace(')','').replace(/\"/gi, "");
            var $percent = $('.set-' + i + ' input').val();
            var $percentDec = $percent / 95; // boost it 
  
            $('.tile.show.primary').each(function() {        
                var $rand = Math.random();
                if ($rand < $percentDec) {
                   $(this).css('background-image', 'url(' + $img2 + ')');
                   $(this).removeClass('primary');
          		 $(this).addClass('color-' + i);
                }
            }); 
            
            // low percent inclusion      
            var $colorCount = $('.tile.show.color-' + i).length
            var $primaryCount = $('.tile.show.primary').length
            if ($colorCount < 1) { 
  			  var $rand = Math.floor(Math.random() * ($primaryCount+1));
  			  $('.tile.show.primary:eq(' + $rand + ')').css('background-image', 'url(' + $img2 + ')');
                $('.tile.show.primary:eq(' + $rand + ')').removeClass('primary');
          	  $(this).addClass('color-' + i); 
            }
                              
          } 
        }                           
                                         
        setTimeout(function(){ 
          if( $prevAnim != 2 ) {                        
            $('.preview-overlay').addClass('anim-2');
          } 
  		$('.preview-overlay').removeClass('anim-1');
        }, 300);
  
  	  //backup
  	  setTimeout(function(){
  		$('.preview-overlay').removeClass('anim-1'); 
        }, 800);
    
      }, 400);
    }
  
  
  
    $(function() {
      $('.contact-form select').selectric();   
    });
    $('.contact-form select').on('selectric-init', function() {
      $('.contact-form .selectric-items li:contains("N/A")').hide();
    });
    
    $('.contact-form .expand label').click(function() {
      $(this).parent().toggleClass('open');
    });
  
    $('.contact-form input#international_PhoneNumber_countrycode').focusin(function(){
      $(this).next('.expand').addClass('open');
    });
    $('.contact-form select').on('selectric-select', function(event, element, selectric) {
      $(element).parent().parent().parent('.expand').next('.expand').addClass('open');
    });


    // mid-mod

      $('.blend').click(function() { 
        if (!$(this).hasClass('active')) {
          var $blend = $(this).data('blend');
          $('.blend.active').removeClass('active');
          $(this).addClass('active');
          var $prevAnim = 0;
          if( $('.blends-presets .preview-overlay').hasClass('anim-2') ) {                         
            $('.blends-presets .preview-overlay').removeClass('anim-2');
            var $prevAnim = 2;
          }
          $('.blends-presets .preview-overlay').addClass('anim-1');
      	setTimeout(function(){ 
            if( $prevAnim != 2 ) {                        
              $('.blends-presets .preview-overlay').addClass('anim-2');
            }
            $('.blend-img.active').removeClass('active'); 
            $('.blend-img[data-blend="' + $blend + '"]').addClass('active');
            $('.blends-presets .preview-overlay').removeClass('anim-1');
          }, 300);
        }
      });

  
});

$(window).resize(function() {
  squaressHeight();
  diamondsHeight();  
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["color-palette-body"]) return;
  try {
    
$(document).ready(function() { 
  
  // SWITCH TYPE
  $('.palette-hero .btn-rounded').on('click', function() {
    if ($(this).hasClass('active')) {
      $('html, body').animate({
        scrollTop: $('.colors-body').offset().top
      }, 500);
    } else {
      $('.palette-hero .btn-rounded, .palette-hero #colors-nav, .colors-body .colors').toggleClass('active');
    };
  });

  // HOVER DELAY
  var $colors = $('.colors-body .color .panel');
  $colors.mouseleave(function() {
    $(this).addClass('hovered');
    var $color = $(this);
    setTimeout(function() {
      $color.removeClass('hovered');
    }, 350);
  });

  // CART BUILDER
  // init
  $.ajax({ 
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function (cart) {
      $('.color .action').each(function () {
        var variantId = $(this).data('product');
        var isInCart = cart.items.some(function (item) {
          return item.variant_id == variantId;
        });
        if (isInCart) {
          console.log('Variant ' + variantId + ' is in the cart.');
          $(this).addClass('active');
          $('.fancybox[data-id="' + variantId + '"').attr('data-cart', 'true'); 
        }
        $(this).addClass('init');
      });
    }/*,
    error: function (error) {
      console.error('Error fetching cart information:', error);
    }*/
  });

  // action
  $('.color .action, .btn-cart').on('click', function() { 
    var variantId = $(this).attr('data-product');
    var $action = $('.color .action[data-product="' + variantId + '"]');
    if ($action.hasClass('active')) {
      // remove
      $action.removeClass('active');
      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        dataType: 'json',
        data: {
          quantity: 0,
          id: variantId
        },
        success: function (response) {
          //console.log('Product removed from cart:', response);
          updateCartCounter();
        },
        error: function (error) {
          console.error('Error removing product to cart:', error);
        }
      });
      $('.fancybox[data-id="' + variantId + '"').attr('data-cart', 'false');
    } else {
      // add
      $action.addClass('active');
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: {
          quantity: 1,
          id: variantId
        },
        success: function (response) {
          //console.log('Product added to cart:', response);
          updateCartCounter();
        },
        error: function (error) {
          console.error('Error adding product to cart:', error);
        }
      });
      $('.fancybox[data-id="' + variantId + '"').attr('data-cart', 'true'); 
    };
    Fancybox.close();  
  });
  
  function updateCartCounter() { 
    $.ajax({
      type: 'GET',
      url: '/cart.js',
      dataType: 'json',
      success: function (cart) {
        $('.cart-text').text(cart.item_count);
      },
      error: function (error) {
        console.error('Error fetching cart information:', error);
      }
    });
  }

  // POPUPS
  var selectors = {
    img: '.color img',
    popup_products: '#popup-products',
    popup_noproducts: '#popup-no-products',
    popup_packs: '#popup-packs'
  };
  
  var popup_type = selectors.popup_noproducts;

  // Load all products
  var products = [];
  var productsURL = '/collections/best-sellers/products.json?limit=1000';
  $.getJSON(productsURL, function(data) {
    products = data.products || [];

    // If direct link with color name used
    if (location.hash.length) {
      setTimeout(function() {
        $('.btn.fancybox[href*="' + location.hash + '"]').trigger('click');
      },100);
    }
  });

  // Open color palette popup 
  $('.fancybox').on('click', function() { 
    var colorType = $(this).data('type');
    console.log('type:', colorType);
    var colorName = $(this).data('color');
    console.log('color:', colorName);
    var colorLink = $(this).data('link');
    console.log('link:', colorLink);
    var colorId = $(this).data('id');
    console.log('id:', colorId);
    var colorCart = $(this).attr('data-cart');
    console.log('cart:', colorCart);
    var colorPrice = $(this).data('price');
    console.log('price:', colorPrice);
    var colorProps = $(this).parent().find('h4').html();
    console.log('props:', colorProps);
    var colorDesc = $(this).parent().find('.desc').text();
    console.log('desc:', colorProps);
    var colorImgs = []

    var colorSwatch = $(this).parent().parent().parent().parent('.panel').find('.img-main').attr('src');
    var colorImg = $(this).parent().parent('.expand').find('.img').attr('style');
    /*$(this).parent().parent().parent().parent().parent('.color').find('.slider-images span').each(function() {
      var url = $(this).attr('data');
      colorImgs.push(url);
    });*/
    
    addPopupContent({
      colorType: colorType,
      colorName: colorName,
      colorId: colorId,
      colorCart: colorCart,
      colorLink: colorLink,
      colorPrice: colorPrice,
      colorProps: colorProps,
      colorDesc: colorDesc,
      colorSwatch: colorSwatch,
      colorImg: colorImg,
      colorImgs: colorImgs,
      onComplete: function() {
        Fancybox.show([{
            src  : popup_type,
            type : 'inline',
            opts : {
              beforeLoad: function() {},
              afterShow : function(instance, current) {}
            },
            helpers: {
              overlay: {
                locked: false
              }
            }
        }]);
      }
    });
  });

  function addPopupContent(options) {
    var colorType = options.colorType,
        colorName = options.colorName,
        colorId = options.colorId,
        colorCart = options.colorCart,
        colorLink = options.colorLink,
        colorPrice = options.colorPrice,
        colorProps = options.colorProps;
        colorDesc = options.colorDesc;
        colorSwatch = options.colorSwatch;
        colorImg = options.colorImg;
        colorImgs = options.colorImgs;
    
    if (colorType == 'color') {

      // Assign products
      var filterProductsByColorName = [];
      if (products && products.length) {
        filterProductsByColorName = products.filter(function(product) {
          var tags = product.tags.join(',').toLowerCase();
          var title = product.title.toLowerCase();

          return tags.indexOf(colorName.toLowerCase()) > -1 || title.indexOf(colorName.toLowerCase()) > -1;
        });
      }

      if (filterProductsByColorName.length) { // color w/ products
        popup_type = selectors.popup_products;

        $('.products', popup_type).html('');
        $('.products-blends p', popup_type).html('');
        $('.products-blends').hide();

        filterProductsByColorName.forEach(function(product, index) {
          if (index < 6) {
            if (~product.title.indexOf('Blend')) {
              var productTitle = product.title.split(' - ');
              $('.products-blends p', popup_type).append('<a href="/products/' + product.handle + '">' + productTitle[0] + '<br/>' + productTitle[1] + '</a>');
              $('.products-blends').show();
            } else {
              var productTitle = product.title.split(' - ');
              $('.products', popup_type).append('<a href="/products/' + product.handle + '">' + productTitle[0] + '</a>');
            };
          }
        });
      } else { // color no products
        popup_type = selectors.popup_noproducts;
      }

      if ($('.popup-slider', popup_type).hasClass('slick-slider')) {
        $('.popup-slider', popup_type).slick('unslick');
      }
      $('.popup-slider .slide', popup_type).remove(); // clear
      $('.popup-slider', popup_type).addClass('loading');
      $('.popup-slider', popup_type).append('<div class="slide"><div><div class="img-wrap"><img src="' + colorSwatch + '" /></div></div></div>');
      $('.popup-slider', popup_type).append('<div class="slide" style="' + colorImg + '"></div>');

    } else { // packs
      
      popup_type = selectors.popup_packs; 
      $('a.btn', popup_type).attr('href', colorLink);
      $('.btn-cart span', popup_type).text(colorPrice); 

      if ($('.popup-slider', popup_type).hasClass('slick-slider')) { 
        $('.popup-slider', popup_type).slick('unslick');
      }
      $('.popup-slider .slide', popup_type).remove(); // clear
      $('.popup-slider', popup_type).addClass('loading');
      $('.popup-slider', popup_type).append('<div class="slide" style="background-image: url(' + colorSwatch + ');"></div>'); 
      $('.popup-slider', popup_type).append('<div class="slide" style="' + colorImg + '"></div>');
      
    }

    // all
    $('.color-name', popup_type).html('<h2>' + colorName + '</h2>');
    $('.color-props', popup_type).html('<h4>' + colorProps + '</h4>');
    $('.color-desc', popup_type).html('<p>' + colorDesc + '</p>');
    $('.btn-cart', popup_type).attr('data-product', colorId);
    if (colorCart == 'true') { 
      $('.btn-cart', popup_type).hide();
    } else {
      $('.btn-cart', popup_type).show();
    }

    /*$.each(colorImgs, function(index, item) {
      $('.popup-slider', popup_type).append('<div class="slide" style="background-image: url(' + item + ');"></div>');
    });*/

    $('.popup-slider', popup_type).slick({
      slidesToShow: 1,
      arrows: true,
      dots: true,
      infinite: true,

    })
    .on('setPosition', function (event, slick) {
      slick.$slides.css('height', slick.$slideTrack.height() + 'px');
    });
    $('.popup-slider', popup_type).slick('slickGoTo', 0);
    setTimeout(function() { 
      $('.popup-slider', popup_type).removeClass('loading');
    }, 500);
    
    options.onComplete();
  }
  
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-blends"]) return;
  try {
    

function squaressHeight() {
  var $squaresWidth = $('.preview[data-shape="squares"]').width();
  var $squaresCol = $('.preview[data-shape="squares"]').attr('data-col').split('-')[1]; 
  $('.preview[data-shape="squares"]').height($squaresWidth + ($squaresCol * 2)); // math accounts for borders 
  $('.preview[data-shape="squares"] .preview-overlay').height($squaresWidth + ( ($squaresCol * 2) - 1) ); 
} 
  
function diamondsHeight() {
  var $diamondsWidth = $('.preview[data-shape="diamonds"]').width();
  var $diamondsCol = $('.preview[data-shape="diamonds"]').attr('data-col').split('-')[1]; 
  var $cubeWidth = (($diamondsWidth / $diamondsCol));  
  var $tileWidth = ($cubeWidth / 1.75);

  
  console.log($diamondsWidth);
  console.log($diamondsCol);  
  console.log($cubeWidth);
  console.log($tileWidth)
  $('.preview[data-shape="diamonds"]').height($diamondsWidth);
  
  $('.preview .diamonds-row').css('margin-bottom', $cubeWidth * -.265);
  $('.preview .diamonds-row:first-child').css('margin-top', $cubeWidth * -.95);
  $('.preview .diamonds-row:nth-child(odd)').width($diamondsWidth + $cubeWidth).css('left', $cubeWidth / -2); 
  
  $('.preview .cube-wrap').width($cubeWidth);  
  $('.preview .cube-wrap').height($tileWidth * 2);
  $('.preview .cube .tile').width($tileWidth).height($tileWidth); 
  
} 

$( document ).ready(function() {

  squaressHeight();
  diamondsHeight(); 
  
  var $type = 'advanced';
  var $shape = 'squares'; 
  $('.blends-nav .btn-tag, .blends-type .switch-type').click(function() { 
    if( !$(this).hasClass('active') ) {

      $type = $(this).data('tag'); 
      console.log($type);
      $shape = $(this).data('shape');
      console.log($shape);

      // nav btns
      if ( !$(this).hasClass('switch-type') ) {
        $('.blends-nav .btn-tag').removeClass('active');
        $(this).addClass('active');

        // new form
        $('#shape li.selected').click();
        if ($shape == 'squares') { 
          $('#shape li[data-index="1"]').click();
        };
        if ($shape == 'diamonds') {
          $('#shape li[data-index="5"]').click();
        };
        if ($shape == 'mid-mod') {
          $('#shape li[data-index="6"]').click();
        };
        if ($shape == 'rise') {
          $('#shape li[data-index="7"]').click(); 
        };
        $('#shape:not(.open)').addClass('open'); 
 
      } 

      // type
      if( !$('.blends-panel .blends-type[data-tag="' + $type + '"]').hasClass('active') ) {
        $('.blends-panel .blends-type').removeClass('active');
        $('.blends-panel .blends-type[data-tag="' + $type + '"]').addClass('active');
      }
      
      // colors panel
      $('.blends-panel .switch-type').removeClass('current-shape');
      $('.blends-panel .switch-type[data-shape="' + $shape + '"]').addClass('current-shape');
      if ( $type == 'advanced') { 
        if( !$('.blends-advanced .preview[data-shape="' + $shape + '"]').hasClass('active') ) {
          $('.blends-advanced .preview').removeClass('active');
          $('.blends-advanced .preview[data-shape="' + $shape + '"]').addClass('active');
        }
      } else { // presets
        $('.blends-presets .blend').removeClass('current-shape'); 
        $('.blends-presets .blend[data-shape="' + $shape + '"]').addClass('current-shape');  
        $('.blends-presets .blend.current-shape')[0].click(); 
      }
       
     
      
      
      

      
    }
  }); 

  /*$('.blends-type .switch-type').click(function() {
    $type = $(this).data('tag');

    // panel
      if( !$('.blends-panel .blends-type[data-tag="' + $type + '"]').hasClass('active') ) {
        $('.blends-panel .blends-type').removeClass('active');
        $('.blends-panel .blends-type[data-tag="' + $type + '"]').addClass('active');
      }
    
  });*/
  

  var $first = 0;
  var $row = 6;
  var $grid = $row * $row;
  
  // Select Color
  $('.colors .swatch').click(function() {
    console.log($type);

    if (!$(this).parent().parent().hasClass('blend')) {
  
    	var $prevColor = $(this).parent().find('.active')
    	$prevColor.removeClass('active');
        $(this).addClass('active');
    
    	if ( !$(this).parent().hasClass('selected') ) {
    	  $(this).parent().addClass('selected');
    	}
    
    	var $prevAnim = 0;
        if( $('.preview-overlay').hasClass('anim-2') ) {                         
          $('.preview-overlay').removeClass('anim-2');
          var $prevAnim = 2;
        }
        $('.preview-overlay').addClass('anim-1');
    	updatePreview($prevAnim);
    
    	// update form 
    	var $codePrev = $prevColor.find('.code').text();
    	if ($codePrev == '') {
    	  $codePrev = 'n/a'; 
    	}
    	var $code = $(this).find('.code').text(); 
    	if ($(this).parent().parent('.set').hasClass('set-1')) { 
          
          /* old form
    	  $('.free-quote-body select[name="MultipleChoice2"] option').prop('selected', false);  
    	  var $list = $('select[name="MultipleChoice2"]');
    	  var $option = $('.free-quote-body select[name="MultipleChoice2"] option:contains("' + $code + '")');  
          $option.prop('selected', true); 
    	  $list.scrollTop($list.scrollTop() + $option.position().top);*/
    
          // new form
          $('#primary-color li.selected').click();
          $('#primary-color:not(.open)').addClass('open'); 
          $('#primary-color li').each(function() {
            if ( $(this).text().split(' ').pop() == $code ) {
              $(this).click();
            }
          }); 
          
    	} else {
    
          /* old form
    	  var $optionPrev = $('.free-quote-body select[name="MultipleChoice3"] option:contains("' + $codePrev + '")'); 
    	  $optionPrev.prop('selected', false);
    	  var $list = $('select[name="MultipleChoice3"]');
    	  var $option = $('.free-quote-body select[name="MultipleChoice3"] option:contains("' + $code + '")');
          $option.prop('selected', true); 
    	  $list.scrollTop($list.scrollTop() + $option.position().top);*/
    
          // new form
          $('#secondary-color li.selected').click(); 
          $('#secondary-color:not(.open)').addClass('open');
          $('#secondary-color li').each(function() {
            if ( $(this).text().split(' ').pop() == $code ) {
              $(this).click();
            }
          }); 
          
    	} 

      }
    
    });

    // Add Color
    $('.add-set').click(function() {
  	$('.colors').find('.set.active').last().next('.set').addClass('active');
  	activeCount = $('.colors .set.active').length;
  	if (activeCount > 3) {
  		$(this).addClass('disabled');
  	}
  	
  	// resets
  	if (activeCount == 3) {
  		$('.colors .set.active:nth-child(1) input').val(50)
  		$('.colors .set.active:nth-child(2) input, .colors .set.active:nth-child(3) input').val(25);
  	}
  	if (activeCount == 4) {
  		$('.colors .set.active:nth-child(1) input').val(50);
  		$('.colors .set.active:nth-child(2) input, .colors .set.active:nth-child(3) input').val(20);
  		$('.colors .set.active:nth-child(4) input').val(10);
  	}
  	
    });
    
    // Remove Color
    $('.remove-set').click(function() {
  	var $prevColor = $(this).parent('.set').find('.swatch.active')
  	$(this).parent('.set').find('.swatch.active').removeClass('active') 
  	
  	$(this).parent('.set').find('.swatches').removeClass('selected')
      $('.colors').find('.set.active').last().removeClass('active') 
  	activeCount = $('.colors .set.active').length; 
  	if (activeCount < 4) {
        if ($('.add-set').hasClass('disabled')) {                             
  		$('.add-set').removeClass('disabled');
        }
  	}
                                              
      // resets 
      if (activeCount == 2) {
  		$('.colors .set.active:nth-child(1) input').val(80); 
  		$('.colors .set.active:nth-child(2) input').val(20);
  	}
  	if (activeCount == 3) {
  		$('.colors .set.active:nth-child(1) input').val(50);
  		$('.colors .set.active:nth-child(2) input, .colors .set.active:nth-child(3) input').val(25);
  	}
      
      // update preview
      var $prevAnim = 0;
      if( $('.preview-overlay').hasClass('anim-2') ) {                         
        $('.preview-overlay').removeClass('anim-2');
        var $prevAnim = 2;
      }
      $('.preview-overlay').addClass('anim-1');
  	updatePreview($prevAnim);
                          
      // update form 
      var $codePrev = $prevColor.find('.code').text();
  	if ($codePrev == '') {
  	  $codePrev = 'n/a'; 
  	}
  
      /* old form
      var $optionPrev = $('.free-quote-body select[name="MultipleChoice3"] option:contains("' + $codePrev + '")');
  	$optionPrev.prop('selected', false);*/
  
      // new form
      $('#secondary-color li.selected').click(); 
      
    });
                       
                          
    // Change Percent                  
    $('.set input').on('change', function() {           
                          
  	var $val = $(this).val();
      var activeCount = $('.colors .set.active').length;
  
      // 5 min, 95 max 
      if ($val < 5) {
  		$val = 5;
  		$(this).val($val);
          $(this).attr('value', $val); 
  	}
  	if (activeCount == 2) {
        if ($val > 95) {
            $val = 95;
            $(this).val($val);
            $(this).attr('value', $val); 
        }
  	}
  	if (activeCount == 3) {
        if ($val > 90) {
            $val = 90;
            $(this).val($val);
            $(this).attr('value', $val); 
        }
  	}
  	if (activeCount == 4) { 
        if ($val > 85) {
            $val = 85;
            $(this).val($val);
            $(this).attr('value', $val); 
        }
  	}
                      
      // 2 active
  	if (activeCount == 2) {
          if ($(this).parent().parent('.set').hasClass('set-1')) {
          	$('.set-2 input').val(100 - $val);
              $('.set-2 input').attr('value', 100 - $val);
          }
  		if ($(this).parent().parent('.set').hasClass('set-2')) {
          	$('.set-1 input').val(100 - $val);
              $('.set-1 input').attr('value', 100 - $val);
          }
  	}
        
      // 3 active
      if (activeCount == 3) {  
          var $val1 = $('.set-1 input').val()
          var $val2 = $('.set-2 input').val()
          // 1
          if ($(this).parent().parent('.set').hasClass('set-1')) {
              $newVal3 = (100 - $val2) - $val;
              if ($newVal3 < 5) {
  				$newVal3 = 5;
  				var $newVal2 = (100 - $val1) - 5;
  				$('.set-2 input').val($newVal2);
  				$('.set-2 input').attr('value', $newVal2);
  			}
          	$('.set-3 input').val($newVal3);
          }
  		// 2
          if ($(this).parent().parent('.set').hasClass('set-2')) {
              $newVal3 = (100 - $val1) - $val;
              if ($newVal3 < 5) {
  				$newVal3 = 5;
  				var $newVal1 = (100 - $val) - 5;
  				$('.set-1 input').val($newVal1);
                  $('.set-1 input').attr('value', $newVal1);
  			}
          	$('.set-3 input').val($newVal3);
              $('.set-3 input').attr('value', $newVal3);
          }
          // 3
          if ($(this).parent().parent('.set').hasClass('set-3')) {
              $newVal2 = (100 - $val1) - $val;
              if ($newVal2 < 5) {
  				$newVal2 = 5;
  				var $newVal1 = (100 - $val) - 5;
  				$('.set-1 input').val($newVal1);
  			}
          	$('.set-2 input').val($newVal2);
  		    $('.set-2 input').attr('value', $newVal2); 
          }
  		
  	}
                          
      // 4 active 
      if (activeCount == 4) {    
          var $val1 = $('.set-1 input').val()
          var $val2 = $('.set-2 input').val()
  		var $val3 = $('.set-3 input').val()
  		var $val4 = $('.set-4 input').val()
          // 1
          if ($(this).parent().parent('.set').hasClass('set-1')) {
              $newVal4 = (100 - $val2 - $val3) - $val;
              if ($newVal4 < 5) {
  				$newVal4 = 5;
  				var $newVal3 = (100 - $val1 - $val2) - 5;
                  if ($newVal3 < 5) {
  					$newVal3 = 5;
                      var $newVal2 = (100 - $val1) - 5 - 5;
  					$('.set-2 input').val($newVal2);
  					$('.set-2 input').attr('value', $newVal2);
  					if ($newVal2 < 5) {
                          $newVal2 = 5;
                          var $newVal1 = 100 -5 - 5 - 5;
                          $('.set-1 input').val($newVal1);
                          $('.set-1 input').attr('value', $newVal1);
                      }
                      $('.set-2 input').val($newVal2);
                      $('.set-2 input').attr('value', $newVal2);
  				}
  				$('.set-3 input').val($newVal3);
                  $('.set-3 input').attr('value', $newVal3);
  			}
          	$('.set-4 input').val($newVal4);
              $('.set-4 input').attr('value', $newVal4);
          }
  		// 2   
          if ($(this).parent().parent('.set').hasClass('set-2')) {
              $newVal4 = (100 - $val1 - $val3) - $val;
              if ($newVal4 < 5) {
  				$newVal4 = 5;
  				var $newVal3 = (100 - $val1 - $val2) - 5;
                  if ($newVal3 < 5) {
  					$newVal3 = 5;
                      var $newVal1 = (100 - $val2) - 5 - 5;
  					$('.set-1 input').val($newVal1);
                      $('.set-1 input').attr('value', $newVal1);
  					if ($newVal1 < 5) {
                          $newVal1 = 5;
                          var $newVal2 = 100 -5 - 5 - 5;
                          $('.set-2 input').val($newVal2);
  						$('.set-2 input').attr('value', $newVal2);
                      }
                      $('.set-1 input').val($newVal1);
  					$('.set-1 input').attr('value', $newVal1);
  				}
  				$('.set-3 input').val($newVal3);
  				$('.set-3 input').attr('value', $newVal3);
  			}
          	$('.set-4 input').val($newVal4);
  			$('.set-4 input').attr('value', $newVal4);
          }
  		// 3      
          if ($(this).parent().parent('.set').hasClass('set-3')) {
              $newVal4 = (100 - $val1 - $val2) - $val;
              if ($newVal4 < 5) {
  				$newVal4 = 5;
  				var $newVal2 = (100 - $val1 - $val3) - 5;
                  if ($newVal2 < 5) {
  					$newVal2 = 5;
                      var $newVal1 = (100 - $val3) - 5 - 5;
  					$('.set-1 input').val($newVal1);
  					if ($newVal1 < 5) {
                          $newVal1 = 5;
                          var $newVal3 = 100 -5 - 5 - 5;
                          $('.set-3 input').val($newVal3);
                          $('.set-3 input').attr('value', $newVal3);
                      }
                      $('.set-1 input').val($newVal1);
                      $('.set-1 input').attr('value', $newVal1);
  				}
  				$('.set-2 input').val($newVal2);
                  $('.set-2 input').attr('value', $newVal2);
  			}
          	$('.set-4 input').val($newVal4);
              $('.set-4 input').attr('value', $newVal4);
          }
          // 4       
          if ($(this).parent().parent('.set').hasClass('set-4')) {
              $newVal3 = (100 - $val1 - $val2) - $val;
              if ($newVal3 < 5) {
  				$newVal3 = 5;
  				var $newVal2 = (100 - $val1 - $val4) - 5;
                  if ($newVal2 < 5) {
  					$newVal2 = 5;
                      var $newVal1 = (100 - $val4) - 5 - 5;
  					$('.set-1 input').val($newVal1);
                      $('.set-1 input').attr('value', $newVal1);
  					if ($newVal1 < 5) {
                          $newVal1 = 5;
                          var $newVal4 = 100 -5 - 5 - 5;
                          $('.set-4 input').val($newVal4);
  						$('.set-4 input').attr('value', $newVal4);
                      }
                      $('.set-1 input').val($newVal1);
  					$('.set-1 input').attr('value', $newVal1);
  				}
  				$('.set-2 input').val($newVal2);
  				$('.set-2 input').attr('value', $newVal2);
  			}
          	$('.set-3 input').val($newVal3);
  			$('.set-3 input').attr('value', $newVal3);
          }
  		
  	}  
   
  	var $prevAnim = 0;
      if( $('.preview-overlay').hasClass('anim-2') ) {                         
        $('.preview-overlay').removeClass('anim-2');
        var $prevAnim = 2;
      }
      $('.preview-overlay').addClass('anim-1');
  	updatePreview($prevAnim);
                          
    });                    
                    
    // Square Footage Update
    $('.blends-panel .quantity input').on('change', function() {
  
  	var $len = $(this).val().length;
  	/*if ($len > 1) {
  		$len = $len + 1;
  	}*/
  	$(this).attr('size', $len); 
  
  	  var $prevAnim = 0;
      if( $('.preview-overlay').hasClass('anim-2') ) {                         
        $('.preview-overlay').removeClass('anim-2');
        var $prevAnim = 2;
      }
      $('.preview-overlay').addClass('anim-1');

      var $this = $(this); 
      setTimeout(function( ){
        var $sqft = $this.val();
        const nearest_sq = n => Math.pow(Math.round(Math.sqrt(n)), 2); 
        var $grid = nearest_sq($sqft);
        if ( $grid < 49 ) {
          $grid = 49;
        }   
        if ( $grid > 100 ) {
          $grid = 100;
        }
        var $row = Math.sqrt($grid);

        $('.preview').each(function() {
          if ($(this).data('shape') == 'diamonds') {
            var $colCubes = Math.ceil($row / 1.5);  
            var $rowCubes = $colCubes * 1.3;
            console.log($colCubes);
            console.log($rowCubes);
            $(this).find('.cube-wrap.show').removeClass('show'); 
            $(this).find('.tile.show').removeClass('show');
            $(this).attr('data-col', 'col-' + $colCubes ); 
            for(var i = 0; i <= $rowCubes; i++) {
              if (i % 2 == 0) {
                console.log('even'); 
                $colCubesTemp = $colCubes + 1;
              } else { // odd row
                console.log('odd');
                $colCubesTemp = $colCubes;
              };
              var ii = 1; 
              
              $('.diamonds-row').eq(i).find('.cube-wrap').each(function() {
                if (ii <= $colCubesTemp) {
                  $(this).addClass('show');
                  $(this).find('.tile').addClass('show');
                }
                ii++;
              });
  
              diamondsHeight();
  
            }
            
          } else { // not diamonds
            
            $(this).find('.tile.show').removeClass('show'); 
            $(this).attr('data-col', 'col-' + $row ); 
            for(var i = 1; i <= $grid; i++) {  
              $('.preview .tile').eq(i).addClass('show'); 
            }
            
          }
          
        });

        updatePreview($prevAnim);  
      }.bind($this), 400); 
  
      /* old form
      $('.free-quote-body input[name="Number"]').val($sqft).change();*/
  
      // new form
      $('#square-footage li.selected').click();
      $('#square-footage:not(.open)').addClass('open');
      if ($sqft < 25) {
        $('#square-footage li[data-index="1"]').click();
      } else if ($sqft < 50) {
        $('#square-footage li[data-index="2"]').click();
      } else if ($sqft < 150) {
        $('#square-footage li[data-index="3"]').click();
      } else if ($sqft < 250) {
        $('#square-footage li[data-index="4"]').click();
      } else {
        $('#square-footage li[data-index="5"]').click(); 
      }
                       
    }); 
                               
    
    // Update Preview                                 
    function updatePreview($prevAnim) {  
  
  	$('.tile.show').addClass('primary');
  	$('.tile.show').removeClass('color-2');
  	$('.tile.show').removeClass('color-3');
  	$('.tile.show').removeClass('color-4');
  
      setTimeout(function(){
                               
        var $grid = $('.preview .tile.show').length;     	
  
  	  $('.tile').css('background-image', 'none'); 
  		
  	  // 1
        if( $('.set-1 .swatches').hasClass('selected') ) {
          var $img = $('.set-1 .swatch.active').css('background-image');
          $img = $img.replace('url(','').replace(')','').replace(/\"/gi, "");
  		$('.tile.show.primary').css('background-image', 'url(' + $img + ')');
        }
  	 
        for (let i = 2; i < 5; i++) {    
          if( $('.set-' + i + ' .swatches').hasClass('selected') ) {
            var $img2 = $('.set-' + i + ' .swatch.active').css('background-image');
            $img2 = $img2.replace('url(','').replace(')','').replace(/\"/gi, "");
            var $percent = $('.set-' + i + ' input').val();
            var $percentDec = $percent / 95; // boost it 
  
            $('.tile.show.primary').each(function() {        
                var $rand = Math.random();
                if ($rand < $percentDec) {
                   $(this).css('background-image', 'url(' + $img2 + ')');
                   $(this).removeClass('primary');
          		 $(this).addClass('color-' + i);
                }
            }); 
            
            // low percent inclusion      
            var $colorCount = $('.tile.show.color-' + i).length
            var $primaryCount = $('.tile.show.primary').length
            if ($colorCount < 1) { 
  			  var $rand = Math.floor(Math.random() * ($primaryCount+1));
  			  $('.tile.show.primary:eq(' + $rand + ')').css('background-image', 'url(' + $img2 + ')');
                $('.tile.show.primary:eq(' + $rand + ')').removeClass('primary');
          	  $(this).addClass('color-' + i); 
            }
                              
          } 
        }                           
                                         
        setTimeout(function(){ 
          if( $prevAnim != 2 ) {                        
            $('.preview-overlay').addClass('anim-2');
          } 
  		$('.preview-overlay').removeClass('anim-1');
        }, 300);
  
  	  //backup
  	  setTimeout(function(){
  		$('.preview-overlay').removeClass('anim-1'); 
        }, 800);
    
      }, 400);
    }
  
  
  
    $(function() {
      $('.contact-form select').selectric();   
    });
    $('.contact-form select').on('selectric-init', function() {
      $('.contact-form .selectric-items li:contains("N/A")').hide();
    });
    
    $('.contact-form .expand label').click(function() {
      $(this).parent().toggleClass('open');
    });
  
    $('.contact-form input#international_PhoneNumber_countrycode').focusin(function(){
      $(this).next('.expand').addClass('open');
    });
    $('.contact-form select').on('selectric-select', function(event, element, selectric) {
      $(element).parent().parent().parent('.expand').next('.expand').addClass('open');
    });


    $('.blend').click(function() { 
      if (!$(this).hasClass('active')) {
        var $blend = $(this).data('blend');
        var $shape = $(this).data('shape');
        console.log('SHAPE: ' + $shape);
        $('.blend.active').removeClass('active');
        $(this).addClass('active');
        var $prevAnim = 0;
        if( $('.blends-presets .preview-overlay').hasClass('anim-2') ) {                         
          $('.blends-presets .preview-overlay').removeClass('anim-2');
          var $prevAnim = 2;
        }
        $('.blends-presets .preview-overlay').addClass('anim-1');
      setTimeout(function(){ 
          if( $prevAnim != 2 ) {                        
            $('.blends-presets .preview-overlay').addClass('anim-2');
          }
          $('.blend-img.active').removeClass('active'); 
          $('.blend-img[data-blend="' + $blend + '"][data-shape="' + $shape + '"]').addClass('active');
          $('.blends-presets .preview-overlay').removeClass('anim-1');
        }, 300);
      }
    });

  
});

$(window).resize(function() {
  squaressHeight();
  diamondsHeight();  
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-custom"]) return;
  try {
    

$( document ).ready(function() { 

  $(function() {
    $('.contact-form select').selectric();  
  });
  $('.contact-form select').on('selectric-init', function() {
    $('.contact-form .selectric-items li:contains("N/A")').hide();
  });
  

  $('.contact-form .expand label').click(function() {
    $(this).parent().toggleClass('open');
  });

  $('.contact-form input#international_PhoneNumber_countrycode').focusin(function(){
    $(this).next('.expand').addClass('open');
  });
  $('.contact-form select').on('selectric-select', function(event, element, selectric) {
    $(element).parent().parent().parent('.expand').next('.expand').addClass('open');
  });

} );


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-faq"]) return;
  try {
    

$( document ).ready(function() { 
  var id = window.location.hash.substr(1);
  $('#' + id).addClass('open');
  $('#' + id).find('.answer').show();
} );


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-midmod"]) return;
  try {
    
$( document ).ready(function() {
  $('.blend').click(function() {
    if (!$(this).hasClass('active')) {
      var $blend = $(this).data('blend');
      $('.blend.active').removeClass('active');
      $(this).addClass('active');
      var $prevAnim = 0;
      if( $('.preview-overlay').hasClass('anim-2') ) {                         
        $('.preview-overlay').removeClass('anim-2');
        var $prevAnim = 2;
      }
      $('.preview-overlay').addClass('anim-1');
  	setTimeout(function(){ 
        if( $prevAnim != 2 ) {                        
          $('.preview-overlay').addClass('anim-2');
        }
        $('.blend-img.active').removeClass('active'); 
        $('.blend-img[data-blend="' + $blend + '"]').addClass('active');
        $('.preview-overlay').removeClass('anim-1');
      }, 300);
    }
  });
} );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-moody"]) return;
  try {
    
 
/**
 * @author       Rob W <gwnRob@gmail.com>
 * @website      https://stackoverflow.com/a/7513356/938089
 * @version      20190409
 * @description  Executes function on a framed YouTube video (see website link)
 *               For a full list of possible functions, see:
 *               https://developers.google.com/youtube/js_api_reference
 * @param String frame_id The id of (the div containing) the frame
 * @param String func     Desired function to call, eg. "playVideo"
 *        (Function)      Function to call when the player is ready.
 * @param Array  args     (optional) List of arguments to pass to function func*/
function callPlayer(frame_id, func, args) {
    if (window.jQuery && frame_id instanceof jQuery) frame_id = frame_id.get(0).id;
    var iframe = document.getElementById(frame_id);
    if (iframe && iframe.tagName.toUpperCase() != 'IFRAME') {
        iframe = iframe.getElementsByTagName('iframe')[0];
    }

    // When the player is not ready yet, add the event to a queue
    // Each frame_id is associated with an own queue.
    // Each queue has three possible states:
    //  undefined = uninitialised / array = queue / .ready=true = ready
    if (!callPlayer.queue) callPlayer.queue = {};
    var queue = callPlayer.queue[frame_id],
        domReady = document.readyState == 'complete';

    if (domReady && !iframe) {
        // DOM is ready and iframe does not exist. Log a message
        window.console && console.log('callPlayer: Frame not found; id=' + frame_id);
        if (queue) clearInterval(queue.poller);
    } else if (func === 'listening') {
        // Sending the "listener" message to the frame, to request status updates
        if (iframe && iframe.contentWindow) {
            func = '{"event":"listening","id":' + JSON.stringify(''+frame_id) + '}';
            iframe.contentWindow.postMessage(func, '*');
        }
    } else if ((!queue || !queue.ready) && (
               !domReady ||
               iframe && !iframe.contentWindow ||
               typeof func === 'function')) {
        if (!queue) queue = callPlayer.queue[frame_id] = [];
        queue.push([func, args]);
        if (!('poller' in queue)) {
            // keep polling until the document and frame is ready
            queue.poller = setInterval(function() {
                callPlayer(frame_id, 'listening');
            }, 250);
            // Add a global "message" event listener, to catch status updates:
            messageEvent(1, function runOnceReady(e) {
                if (!iframe) {
                    iframe = document.getElementById(frame_id);
                    if (!iframe) return;
                    if (iframe.tagName.toUpperCase() != 'IFRAME') {
                        iframe = iframe.getElementsByTagName('iframe')[0];
                        if (!iframe) return;
                    }
                }
                if (e.source === iframe.contentWindow) {
                    // Assume that the player is ready if we receive a
                    // message from the iframe
                    clearInterval(queue.poller);
                    queue.ready = true;
                    messageEvent(0, runOnceReady);
                    // .. and release the queue:
                    while (tmp = queue.shift()) {
                        callPlayer(frame_id, tmp[0], tmp[1]);
                    }
                }
            }, false);
        }
    } else if (iframe && iframe.contentWindow) {
        // When a function is supplied, just call it (like "onYouTubePlayerReady")
        if (func.call) return func();
        // Frame exists, send message
        iframe.contentWindow.postMessage(JSON.stringify({
            "event": "command",
            "func": func,
            "args": args || [],
            "id": frame_id
        }), "*");
    }
    /* IE8 does not support addEventListener... */
    function messageEvent(add, listener) {
        var w3 = add ? window.addEventListener : window.removeEventListener;
        w3 ?
            w3('message', listener, !1)
        :
            (add ? window.attachEvent : window.detachEvent)('onmessage', listener);
    }
}
  
$( document ).ready(function() { 
  callPlayer("hero-vid-embed", function() {
    callPlayer("hero-vid-embed", "playVideo");
    setTimeout(function() { 
      $('#hero-vid-embed').addClass('show'); 
    }, 1000);
  });
} );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-next"]) return;
  try {
    
/*$( document ).ready(function() { 
} );*/

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-quiz"]) return;
  try {
    
$('.option').click(function() { 
	$(this).parent('.option-wrap').parent('.options').find('.option').removeClass('selected');
	//$(this).parent('.option-wrap').parent('.options').find('input').val('');
	$(this).addClass('selected');
	next = $(this).parent('.option-wrap').parent('.options').parent('.question').next('.question').attr('id');
    next_sel = '#' + next
	if(next_sel === '#undefined') { // on Q6
      next_sel = '#quiz-submit';

	  // login redirect url
	  var $url =  'https://mercurymosaics.com/pages/quiz/';  
	  q1 = $('.option.selected[data-question="1"]').attr('data-result');
      q2 = $('.option.selected[data-question="2"]').attr('data-result');
      q3 = $('.option.selected[data-question="3"]').attr('data-result');
      q4 = $('.option.selected[data-question="4"]').attr('data-result');
      q5 = $('.option.selected[data-question="5"]').attr('data-result');
      q6 = $('.option.selected[data-question="6"]').attr('data-result'); 

  	  $("#redirect_url").val($url + '?q1=' + q1 + '&q2=' + q2 + '&q3=' + q3 + '&q4=' + q4 + '&q5=' + q5 + '&q6=' + q6); 

	  //$('#zoho-form input[name="returnURL"]').val($url + '?q1=' + q1 + '&q2=' + q2 + '&q3=' + q3 + '&q4=' + q4 + '&q5=' + q5 + '&q6=' + q6).change();
      //console.log($('#zoho-form input[name="returnURL"]').val()) 
	}

	$(next_sel).addClass('show');
	$('html,body').animate({
        scrollTop: $(next_sel).offset().top - 150
    }, 'slow');

	//var $q = $(this).attr('data-question'); 
	//var $val = $(this).attr('data-result');
	//var $q2 = parseInt($q) + 6;
	//var $val2 = $(this).find('h3').text();
	//$('#mce-Q' + $q).val($val).change(); 
	//$('#zoho-form input[name="SingleLine' + $q + '"]').val($val).change();
	//$('#zoho-form input[name="SingleLine' + $q2 + '"]').val($val2).change();
});

var marketing = 'Yes';
$('.checkbox').click(function() { 
	if($(this).hasClass('checked')) {
		$(this).removeClass('checked');
        marketing = 'No';
		//$('#mce-MARKETING').val('No')
	} else {
		$(this).addClass('checked');
        marketing = 'Yes';
		//$('#mce-MARKETING').val('Yes') 
	}
});

$('#sign-in').click(function() {

	var $a = $('.option.selected[data-result~=a]').length; 
	var $b = $('.option.selected[data-result~=b]').length; 
	var $c = $('.option.selected[data-result~=c]').length;
	var $d = $('.option.selected[data-result~=d]').length;
	var $e = $('.option.selected[data-result~=e]').length;
	var obj = { a: $a, b: $b, c: $c, d: $d, e: $e };
	var max= Number.NEGATIVE_INFINITY;
	var max_key=undefined;
	for(var key in obj){
	  if(obj[key] > max)
	  {
		  max_key = key;
		  max = obj[key];
	  }
	}
	console.log("The key with the maximum value is: "+max_key+" whose value is: "+max);
	
	redir = $("#redirect_url").val();
	redir += '&r=' + max_key;
	$("#redirect_url").val(redir); 
		
	$(this).addClass('remove'); 
	$('#CustomerLoginForm').toggleClass('show'); 

});
        
$('.email-button').on( 'click', function() {
	
	// validation
	if( !$('#fname').val() ) {
	  alert('First Name required.')
	  return false; 
    }
	if( !$('#lname').val() ) {
      alert('Last Name required.')
      return false; 
    }
    if( IsEmail($('#email').val() )==false ) {
      alert('Valid email required.')
      return false; 
    }

	var $a = $('.option.selected[data-result~=a]').length;
	var $b = $('.option.selected[data-result~=b]').length; 
	var $c = $('.option.selected[data-result~=c]').length;
	var $d = $('.option.selected[data-result~=d]').length;
	var $e = $('.option.selected[data-result~=e]').length;
	var obj = { a: $a, b: $b, c: $c, d: $d, e: $e };
	var max= Number.NEGATIVE_INFINITY;
	var max_key=undefined;
	for(var key in obj){
	  if(obj[key] > max)
	  {
		  max_key = key;
		  max = obj[key];
	  }
	}
	console.log("The key with the maximum value is: "+max_key+" whose value is: "+max); 
  
	/*$('#mce-FNAME').val($('#fname').val()).change();
	$('#mce-LNAME').val($('#lname').val()).change();
	$('#mce-EMAIL').val($('#email').val()).change();
	$('#mce-RESULT').val(max_key).change();*/
	/*$('#zoho-form input[name="Name_First"]').val($('#fname').val()).change();
	$('#zoho-form input[name="Name_Last"]').val($('#lname').val()).change();
	$('#zoho-form input[name="Email"]').val($('#email').val()).change();
	$('#zoho-form input[name="SingleLine"]').val(max_key).change();
	var $result2 = $('.result[data-result="' + max_key + '"]').attr('data-result-text'); 
	$('#zoho-form input[name="SingleLine13"]').val($result2).change();*/

    $('.template-page').addClass('done');
	$('.quiz-main').addClass('done');
	$('.quiz-results .intro').addClass('show');
	$('.result[data-result~=' + max_key + ']').addClass('show');
    $('.quiz-results .galleries').addClass('show');
   
	q1 = $('.option.selected[data-question="1"]').attr('data-result');
	if(q1 === undefined) {
      q1 = 'f';
	}
	$('.page-custom-gallery[data-gallery~=' + q1 + ']').addClass('show'); 

	$('html,body').animate({
      scrollTop: $('#results').offset().top
    }, 'slow');

    // Klaviyo
    var settings = {
      "async": true,
      "crossDomain": true,
      "url": "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
      "method": "POST",
      "headers": {
        "content-type": "application/x-www-form-urlencoded",
        "cache-control": "no-cache"
      },
      "data": {
        "g": "YchtAp",
        "email": $('#email').val(),
        "$fields": "$source, $first_name, $last_name, Result, Accepts Marketing",
        "$source": 'Quiz',
        "$first_name": $('#fname').val(),
        "$last_name": $('#lname').val(), 
        "Result": max_key,
        "Accepts Marketing": marketing
      }
    };
    $.ajax(settings).done(function(response) {
      console.log(response); 
    })

  

	//$form = $('#mc-embedded-subscribe-form'); 
	//register($form);

	// zoho redirect url
    //redir = $('#zoho-form input[name="returnURL"]').val();
	//redir += '&r=' + max_key;
	//$('#zoho-form input[name="returnURL"]').val(redir).change(); 

	//$('#zoho-form button').click(); 
    //$('#zoho-form input[type="submit"]').click(); 
});

$('.skip-button').one( 'click', function() {
	var $a = $('.option.selected[data-result~=a]').length;
	var $b = $('.option.selected[data-result~=b]').length;
	var $c = $('.option.selected[data-result~=c]').length;
	var $d = $('.option.selected[data-result~=d]').length; 
	var $e = $('.option.selected[data-result~=e]').length;
	var obj = { a: $a, b: $b, c: $c, d: $d, e: $e };
	var max= Number.NEGATIVE_INFINITY;
	var max_key=undefined;
	for(var key in obj){
	  if(obj[key] > max)
	  {
		  max_key = key;
		  max = obj[key];
	  }
	}
	$('.template-page').addClass('done');
    $('.quiz-main').addClass('done');

	$('.quiz-results .intro').addClass('show');
	$('.result[data-result~=' + max_key + ']').addClass('show');
   
	$('.quiz-results .galleries').addClass('show');
	q1 = $('.option.selected[data-question="1"]').attr('data-result');
	$('.page-custom-gallery[data-gallery~=' + q1 + ']').addClass('show'); 

	$('html,body').animate({
      scrollTop: $('#results').offset().top
    }, 'slow');
});

// Mailchimp Form Submit
/*function register($form) {
    $.ajax({
        type: $form.attr('method'),
        url: $form.attr('action'),
        data: $form.serialize(),
        cache       : false,
        dataType    : 'json',
        contentType: "application/json; charset=utf-8",
        error       : function(err) { console.log("Could not connect to the registration server. Please try again later."); },
        success     : function(data) {
            if (data.result != "success") {
				console.log(data.msg)
            } else {
                console.log('Success')
            }
        }
    });
}*/
	
/*// Randomize Answers
$.fn.randomize = function(selector){
	(selector ? this.find(selector) : this).parent().each(function(){ 
		$(this).children(selector).sort(function(){
			return Math.random() - 0.5;
		}).detach().appendTo(this);
	});
	return this;
};*/
	
$( document ).ready(function() {
	// check params
	var getUrlParameter = function getUrlParameter(sParam) {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
    }
                                             
    q1 = getUrlParameter('q1'); 
    result = getUrlParameter('r'); 
    
    if(q1 != undefined) {  // if back w/ url params
                                             
      $('#q1').removeClass('show');
                                             
      $('.quiz-results .intro').addClass('show');
      $('.result[data-result~=' + result + ']').addClass('show');

      $('.quiz-results .galleries').addClass('show');
      $('.page-custom-gallery[data-gallery~=' + q1 + ']').addClass('show');
                                             
      $('.page-custom-gallery:not([data-gallery=' + q1 + '])').remove();

	}

	/*$('.option-wrap').randomize();*/ 
});

$( window ).load(function() {
	$('.page-custom-gallery').removeClass('init'); 
    $('.galleries').addClass('init');
});
                                             
function IsEmail(email) {
  var regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  if(!regex.test(email)) {
    return false;
  }else{
    return true; 
  }
} 


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-quote"]) return;
  try {
    

  (function($) {
    $('.contact-form select').selectric();
    
    $('.contact-form select').on('selectric-init', function() {
      $('.contact-form .selectric-items li:contains("N/A")').hide();
    });
    
    $('.contact-form .expand label').click(function() {
      $(this).parent().toggleClass('open');
    });
  
    $('.contact-form input#international_PhoneNumber_countrycode').focusin(function(){
      $(this).next('.expand').addClass('open');
    });
    
    $('.contact-form select').on('selectric-select', function(event, element, selectric) {
      $(element).parent().parent().parent('.expand').next('.expand').addClass('open');
    });
  })(jQuery);  


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-rise"]) return;
  try {
    
$( document ).ready(function() {
  $('.blend').click(function() {
    if (!$(this).hasClass('active')) {
      var $blend = $(this).data('blend');
      $('.blend.active').removeClass('active');
      $(this).addClass('active');
      var $prevAnim = 0;
      if( $('.preview-overlay').hasClass('anim-2') ) {                         
        $('.preview-overlay').removeClass('anim-2');
        var $prevAnim = 2;
      }
      $('.preview-overlay').addClass('anim-1');
  	setTimeout(function(){ 
        if( $prevAnim != 2 ) {                        
          $('.preview-overlay').addClass('anim-2');
        }
        $('.blend-img.active').removeClass('active'); 
        $('.blend-img[data-blend="' + $blend + '"]').addClass('active');
        $('.preview-overlay').removeClass('anim-1');
      }, 300);
    }
  });
} );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-survey-reason"]) return;
  try {
    
$( document ).ready(function() {
	// check params
	var getUrlParameter = function getUrlParameter(sParam) {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;
        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');
            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
    }

    email = getUrlParameter('e');
    fname = getUrlParameter('f'); 
    lname = getUrlParameter('l');
    console.log(fname + ' ' + lname)

    $('input[name="Email"]').val(email).change(); 
    $('input[name="SingleLine"]').val(fname).change(); 
    $('input[name="SingleLine1"]').val(lname).change(); 

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-survey"]) return;
  try {
    
$( document ).ready(function() {
	// check params
	var getUrlParameter = function getUrlParameter(sParam) {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;
        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');
            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
    }

    email = getUrlParameter('e');
    fname = getUrlParameter('f'); 
    lname = getUrlParameter('l');
    status = getUrlParameter('s');
    console.log(fname + ' ' + lname)
    console.log('status: ' + status) 

    $('input[name="Email"]').val(email).change(); 
    $('input[name="SingleLine"]').val(fname).change(); 
    $('input[name="SingleLine1"]').val(lname).change();
    $('input:radio[value="' + status + '"]').prop('checked',true).change();

    if (status == '6') { 
      $('input[name="zf_redirect_url"]').val('https://mercurymosaics.com/pages/survey-reason?e=' + email + '&f=' + fname + '&l=' + lname).change();
    };

    $('button[type="submit"]').click();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-visit"]) return;
  try {
    
/*$( document ).ready(function() { 
} );*/

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trade-accepted-processing"]) return;
  try {
    
$( window ).load(function() { 

  var settings = {
    "async": true,
    "crossDomain": true,
    "url": "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
    "method": "POST",
    "headers": {
      "content-type": "application/x-www-form-urlencoded",
      "cache-control": "no-cache"
    },
    "data": {
      "g": "Ts3YWi",
      "email": $('#email').val(), 
      "$fields": "$source, $first_name, $last_name, Company",
      "$source": "Trade",
      "$first_name": $('#fname').val(),
      "$last_name": $('#lname').val(), 
      "Company": $('#company').val()
    }
  };
  $.ajax(settings).done(function(response) {
    console.log(response);

    // Zoho Forms
    setTimeout(function() {
        $('#form button[type="submit"]').click();
    }, 100);
    
  })

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trade-processing"]) return;
  try {
    
$( window ).load(function() {
	setTimeout(function() {
		$('#form button[type="submit"]').click();
	}, 100);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trade-samples-body"]) return;
  try {
    

$( document ).ready(function() { 

  $(function() {
    $('.contact-form select').selectric();  
  });
  $('.contact-form select').on('selectric-init', function() {
    $('.contact-form .selectric-items li:contains("N/A")').hide();
  });
  
  $('.contact-form .expand label').click(function() {
    $(this).parent().toggleClass('open');
  });

  $('.contact-form input#international_PhoneNumber_countrycode').focusin(function(){
    $(this).next('.expand').addClass('open');
  });
  $('.contact-form select').on('selectric-select', function(event, element, selectric) {
    $(element).parent().parent().parent('.expand').next('.expand').addClass('open');
  });
  
} );


  } catch(e) { console.error(e); }
})();
})();
